import styled from '@emotion/styled';
import { useSetAtom } from 'jotai';
import { useTranslation } from 'next-i18next';
import GenericButton from 'src/components/GenericButton';
import ModalLayoutBase, { MobileModalType, ModalContent as ModalContentBase, ModalFooter, ModalLayoutProps } from 'src/components/ModalLayout';
import { closeModalAtom } from 'src/stores/modal/atoms';
import { ModalNavButtonType, ModalType } from 'src/types/Modal';
import { setTargetBlankToLinks } from 'src/utils/html';
const ModalLayout = styled(ModalLayoutBase)`
  width: 360px;
  min-width: 360px;

  ${({
  theme
}) => theme.screenSize.mobile} {
    max-width: 100%;
  }
`;
const ModalContent = styled(ModalContentBase)`
  padding: 24px 24px 16px 24px;
`;
const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
`;
const GuideImage = styled.img`
  width: 100%;
  border-radius: 16px;
  object-fit: cover;
  ${({
  theme
}) => theme.isRtl && `transform: scaleX(-1);`}
`;
const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;
const Title = styled.h2`
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  text-align: center;
  color: ${({
  theme
}) => theme.color.contentDeep};
`;
const Description = styled.p`
  margin: 0;
  font-size: 13px;
  font-weight: 400;
  line-height: 16px;
  text-align: center;
  white-space: pre-line;
  color: ${({
  theme
}) => theme.color.content9};
`;
interface Props extends ModalLayoutProps {
  title: string;
  description: string;
  imageUrl?: string;
}
const BenefitDetailModal = ({
  title,
  description,
  imageUrl,
  ...props
}: Props) => {
  const {
    t
  } = useTranslation();
  const closeModal = useSetAtom(closeModalAtom);
  const handleClose = () => {
    closeModal(ModalType.SUBSCRIPTION_BENEFIT_DETAIL);
  };
  return <ModalLayout {...props} mobileType={MobileModalType.BOTTOM_SHEET} mobileNavButtonType={ModalNavButtonType.NONE} navButtonType={ModalNavButtonType.NONE} onClose={handleClose} isDim data-sentry-element="ModalLayout" data-sentry-component="BenefitDetailModal" data-sentry-source-file="index.tsx">
      <ModalContent data-sentry-element="ModalContent" data-sentry-source-file="index.tsx">
        <Container data-sentry-element="Container" data-sentry-source-file="index.tsx">
          {imageUrl && <GuideImage src={imageUrl} alt='' />}
          <TextContainer data-sentry-element="TextContainer" data-sentry-source-file="index.tsx">
            <Title data-sentry-element="Title" data-sentry-source-file="index.tsx">{title}</Title>
            <Description dangerouslySetInnerHTML={{
            __html: setTargetBlankToLinks(description)
          }} data-sentry-element="Description" data-sentry-source-file="index.tsx" />
          </TextContainer>
        </Container>
      </ModalContent>
      <ModalFooter data-sentry-element="ModalFooter" data-sentry-source-file="index.tsx">
        <GenericButton variant='primary' size='large' onClick={handleClose} data-sentry-element="GenericButton" data-sentry-source-file="index.tsx">
          {t('COMMON__OK')}
        </GenericButton>
      </ModalFooter>
    </ModalLayout>;
};
export default BenefitDetailModal;